import React, { Component } from "react";
import Header from "./Header";
import HeaderIntro from "./HeaderIntro";
import Footer from "./Footer";
import NewsLetter from "./NewsLetter";
export class Selfefiling extends Component {
  render() {
    return (
      <div>
        <Header />
        <HeaderIntro/>
        <section id="contact" style={{ backgroundColor: "#f3f9fd" }}>
        <div className="container">
          <div class="container-fluid" data-aos="fade-up">
            

            <div class="section-header">
              <h3>Self E-Filing </h3>
              <p>
                We are the leading Tech Enabled Platform For Tax Return Filing.
                Self E-File in a few minutes with Utmost Ease and get a
                comprehensive report.
              </p>
            </div>
           
          </div>
          </div>
        </section>
        <NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default Selfefiling;
